import { render, staticRenderFns } from "./DataShowRight.vue?vue&type=template&id=2e3d89cd&scoped=true"
import script from "./DataShowRight.vue?vue&type=script&lang=js"
export * from "./DataShowRight.vue?vue&type=script&lang=js"
import style0 from "./DataShowRight.vue?vue&type=style&index=0&id=2e3d89cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d89cd",
  null
  
)

export default component.exports